import { GRAPHQL_TYPENAMES } from 'modules/graphql/types';
import { ListReferenceSortableProperty } from '../../../types';

export const LIST_USAGE_TYPE = {
  [GRAPHQL_TYPENAMES.CAMPAIGN]: 'Campaign',
  [GRAPHQL_TYPENAMES.JOURNEY]: 'Journey',
  [GRAPHQL_TYPENAMES.LIST]: 'List',
};

export enum TABLE_COLUMNS {
  NAME = 'Name',
  MEDIUM = 'Medium',
  TYPE = 'Type',
  STATUS = 'Status',
  LAST_MODIFIED = 'LastModified',
}

export const SORTABLE_TABLE_COLUMNS_TO_PROPERTIES = {
  [TABLE_COLUMNS.NAME]: ListReferenceSortableProperty.name,
  [TABLE_COLUMNS.TYPE]: ListReferenceSortableProperty.type,
  [TABLE_COLUMNS.LAST_MODIFIED]: ListReferenceSortableProperty.updatedAt,
};

export const ORDERED_TABLE_COLUMNS = [
  TABLE_COLUMNS.NAME,
  TABLE_COLUMNS.MEDIUM,
  TABLE_COLUMNS.TYPE,
  TABLE_COLUMNS.STATUS,
  TABLE_COLUMNS.LAST_MODIFIED,
];

export const TABLE_COLUMN_WIDTHS = {
  [TABLE_COLUMNS.NAME]: 'minmax(0, 1.5fr)',
  [TABLE_COLUMNS.MEDIUM]: '.75fr',
  [TABLE_COLUMNS.TYPE]: '.75fr',
  [TABLE_COLUMNS.STATUS]: '.5fr',
  [TABLE_COLUMNS.LAST_MODIFIED]: '1.25fr',
};

export enum FETCH_REFERENCES_TRIGGER {
  MODAL = 'modal',
  INSIGHTS = 'insights',
}
